import { render, staticRenderFns } from "./EditMenusSubheader.vue?vue&type=template&id=72d5dac0&scoped=true"
import script from "./EditMenusSubheader.vue?vue&type=script&lang=ts"
export * from "./EditMenusSubheader.vue?vue&type=script&lang=ts"
import style0 from "./EditMenusSubheader.vue?vue&type=style&index=0&id=72d5dac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5dac0",
  null
  
)

export default component.exports